module.exports = __webpack_public_path__ + "static/media/galeryAbout1.5994de73.jpg";